import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';

const config = {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    issuer: process.env.REACT_APP_OKTA_ISSUER as string,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    tokenManager: {
        storage: "localStorage",
        autoRenew: false,
        autoRemove: true,
        expireEarlySeconds: 30,
    },
    storageManager: {
        token: {
            storageTypes: ["localStorage"],
        },
        cache: {
            storageTypes: ["sessionStorage"],
        },
    },
} as OktaAuthOptions

export const authClient = new OktaAuth(config)